export default "__VITE_ASSET__D1ZperL8__"